import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SidebarComponent } from './sidebar.component';
import {CalendarModule} from 'primeng/calendar';
import {PaginatorModule} from 'primeng/paginator';

@NgModule({
  imports: [RouterModule, CommonModule, CalendarModule, PaginatorModule],
    declarations: [ SidebarComponent ],
    exports: [ SidebarComponent ]
})

export class SidebarModule {}
